import React from 'react';
import './About.css';
import shakil from '../../images/ShakilAhmed.png';
import CV from '../../images/CV/ShakilAhmed.pdf';


const About = () => {

    return (
        <div id="about-section" className="container about">
            <div className="back-line d-flex align-items-center">
                <div className="front-box d-flex align-items-center">
                    <p className="d-flex align-items-center">About Me</p>
                </div>
            </div>
            <div className="row align-items-center about-padding">
                <div data-aos="flip-down" className="col-md-4 img-size">
                    <img src={shakil} alt="Shakil Ahmed Web Developer" />
                </div>
                <div data-aos="flip-up" className="col-md-8 about-mySelf">
                    <p className="pb-4">I am a Software Engineer with 5+ years of experience in the MERN stack with Next.js, specializing in scalable backend architectures and high-performance frontend applications. Skilled in Node.js, Express.js, MongoDB, React.js, and microservices with gRPC, RabbitMQ, and Redis. Passionate about clean code and building innovative, efficient solutions. Let’s create something amazing! 🚀</p>
                    <a href={CV} download="Shakil Ahmed CV"><button className="btn btn-lg btn-success my-2 my-sm-0 btn-style">Get Resume</button></a>
                    <a href="#skill-section"><button className="btn btn-lg btn-outline-success my-2 my-sm-0 btn-style">My Skill</button></a>
                </div>
            </div>
        </div>
    );
};

export default About;